import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { PlacementFrontend } from '@post-office/browser--marketplace/confluence-sidenav-mpac-recommendations';

import React from 'react';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

// This is the Message Frontend. In this Placement we have render.Component which renders children prop for headless placement.
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation(),

		// eslint-disable-next-line @post-office/message-linting/no-host-children-in-message-template
		Component: ({ children }: { children: React.ReactNode }) => {
			return <>{children}</>;
		},
	},
});
